import { TPayloadCreateInvoice } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const createInvoice = ({ id, payload }: { id: string; payload: TPayloadCreateInvoice }) =>
  API.post(`/api/accommodation/calculations/${id}/invoices/generate`, payload);
